import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Grid, Heading, Tooltip, Button } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { HouseIcon } from '@enterprise-ui/icons';

// eslint-disable-next-line no-unused-vars
var NotFound = function NotFound() {
  return /*#__PURE__*/React.createElement(Card, {
    className: "topPage-container"
  }, /*#__PURE__*/React.createElement(Grid.Container, {
    justify: "center",
    align: "center",
    direction: "column",
    className: "fullHeight-container"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Heading, {
    size: 3
  }, "You seem to have taken a wrong turn.")), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Tooltip, {
    content: "Return Home",
    location: "top"
  }, /*#__PURE__*/React.createElement(Button, {
    iconOnly: true,
    size: "expanded",
    type: "primary",
    as: Link,
    to: "/",
    "aria-label": "Go to the homepage"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    size: "xl",
    icon: HouseIcon
  }))))));
};

export { NotFound as default };
